<template>
  <div v-if="owner" class="FileModalOwner">
    <div class="FileModalOwner__avatar">
      <ProspectAvatar v-if="isProspect || isSelf" disable-tooltip small :prospect="owner.prospect" />
      <UserAvatar v-else-if="isUser" small :user="owner.user" />
      <div v-else-if="isAnonymousProspect" class="FileModalOwner__anonymous">
        {{ anonymousLetter }}
      </div>
      <LogoRound v-else-if="isAnonymousModerator" class="FileModalOwner__moderator" />
    </div>
    <div class="FileModalOwner__info">
      <div class="FileModalOwner__name" :class="{ FileModalOwner__name_moderator: isAnonymousModerator }">
        {{ name }}
      </div>
      <div v-if="notice" class="FileModalOwner__notice">{{ notice }}</div>
    </div>
  </div>
</template>

<script>
import ProspectAvatar from '@/components/modules/prospects/ProspectAvatar.vue'
import UserAvatar from '@/components/modules/users/UserAvatar.vue'
import LogoRound from '@/assets/icons/LogoRound.vue'
import { FileModalOwnerKind } from '@/utils/fileOwner'

export default {
  name: 'FileModalOwner',
  components: { LogoRound, UserAvatar, ProspectAvatar },
  props: {
    owner: { type: Object, default: null }
  },
  computed: {
    kind() {
      return this.owner?.kind || null
    },
    isProspect() {
      return this.kind === FileModalOwnerKind.PROSPECT
    },
    isUser() {
      return this.kind === FileModalOwnerKind.USER
    },
    isSelf() {
      return this.kind === FileModalOwnerKind.SELF
    },
    isAnonymousProspect() {
      return this.kind === FileModalOwnerKind.ANONYMOUS_PROSPECT
    },
    isAnonymousModerator() {
      return this.kind === FileModalOwnerKind.ANONYMOUS_MODERATOR
    },
    anonymousId() {
      return this.owner?.anonymousId || null
    },
    anonymousLetter() {
      return this.$t('forum.response.anonymous_reply_user_name').slice(0, 1)
    },
    name() {
      if (this.isSelf) {
        return this.$t('you')
      }
      if (this.isProspect) {
        return this.owner.prospect?.fullNameWithShortLastName || this.$t('not-available')
      }
      if (this.isUser) {
        return this.owner.user?.fullNameWithShortLastName || this.$t('not-available')
      }
      if (this.isAnonymousProspect) {
        return this.anonymousId
          ? this.$t('forum.response.anonymous_reply_user_name_with_id', { id: this.anonymousId })
          : this.$t('forum.response.anonymous_reply_user_name')
      }
      if (this.isAnonymousModerator) {
        return this.anonymousId
          ? this.$t('forum.response.moderator_reply_user_name_with_id', { id: this.anonymousId })
          : this.$t('forum.response.moderator_reply_user_name')
      }
      return ''
    },
    notice() {
      if (this.isAnonymousProspect) {
        return this.$t('forum.response.anonymous_reply_label')
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.FileModalOwner {
  @apply flex items-center min-w-0;
  &__avatar {
    @apply flex-shrink-0 mr-4;
    width: 48px;
    height: 48px;
  }
  &__anonymous {
    @apply w-full h-full rounded-full bg-neutral-01-400 text-white flex items-center justify-center;
    font-size: 14px;
    line-height: 1;
  }
  &__moderator {
    @apply w-full h-full;
  }
  &__info {
    @apply min-w-0;
  }
  &__name {
    @apply text-body-02 text-primary-01-400 truncate;
    &_moderator {
      @apply text-accent-01;
    }
  }
  &__notice {
    @apply text-neutral-01-400 text-xs italic;
  }
}
</style>
